import I18n from 'I18n';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import EnrollmentAuditEventTypes from 'automation-ui-management/records/AuditHistory/EnrollmentAuditEventTypes';
import RevisionButton from 'automation-ui-management/components/revisions/RevisionButton';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTr = styled.tr.withConfig({
  displayName: "RevisionRollupInsetTableRow__StyledTr",
  componentId: "sc-1lt4g8m-0"
})(({
  theme
}) => `
  && > td:first-child {
    padding-left: ${theme.space['900']};
  }

  && > td {
    white-space: nowrap;
  }
`);
const RevisionRollupInsetTableRow = ({
  flowId,
  version,
  eventTypes,
  timestamp,
  onRevisionSelect
}) => {
  const eventType = eventTypes.first();
  let message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `automation-ui-management.auditEvent.auditEventTypes.${eventType}`
  });
  if (eventTypes.size > 1 && eventTypes.isSubset(EnrollmentAuditEventTypes)) {
    message = eventTypes.map(enrollmentEventType => I18n.text(`automation-ui-management.auditEvent.auditEventTypes.${enrollmentEventType}`).concat('.')).join(' ');
  }
  const handleRevisionSelect = onRevisionSelect ? () => onRevisionSelect(syntheticEvent(version)) : undefined;
  return /*#__PURE__*/_jsxs(StyledTr, {
    children: [/*#__PURE__*/_jsx(UITableHoverCell, {
      hoverContent: /*#__PURE__*/_jsx(UITableHoverContent, {
        children: /*#__PURE__*/_jsx(RevisionButton, {
          version: version,
          flowId: flowId,
          external: false,
          onClick: handleRevisionSelect
        })
      }),
      children: message
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
        useMultiline: true,
        value: timestamp,
        format: "lll z"
      })
    })]
  });
};
export default RevisionRollupInsetTableRow;